import TextFieldProperty from '@/components/Input/TextFieldProperty';

import { splitNumberByDecimal, validateInputOption } from '@/common/utils';

export default {
  props: {
    cornerRounding: {
      type: Number,
      default: 0
    },
    minRounding: {
      type: Number,
      default: 0
    },
    maxRounding: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TextFieldProperty
  },
  computed: {
    cornerRoundingPt() {
      return splitNumberByDecimal(
        this.cornerRounding,
        this.numberOfDecimalRounding
      );
    }
  },
  data() {
    return {
      numberOfDecimalRounding: 1,
      componentKey: 0
    };
  },
  methods: {
    /**
     * Emit corner value to parent
     * @param {Number}  val corner value user entered
     */
    onChangeCornerRounding(val) {
      const corner = splitNumberByDecimal(val, this.numberOfDecimalRounding);
      if (isNaN(corner) || corner == this.cornerRoundingPt) {
        this.onEsc();
        return;
      }
      const { isValid, value, isForce } = validateInputOption(
        corner,
        this.minRounding,
        this.maxRounding,
        this.numberOfDecimalRounding
      );
      if (!isValid) {
        if (corner > this.maxRounding) {
          this.$emit('change', { cornerRounding: this.maxRounding });
        }
        this.forceRenderComponent();
        return;
      }
      this.$emit('change', { cornerRounding: value });
      if (isForce) {
        this.forceRenderComponent();
      }
    },
    /**
     * Trigger render component by increase component key
     * Maybe improve later for performance
     */
    forceRenderComponent() {
      this.componentKey += 1;
    },
    /**
     * Revert to previous data and un focus input element
     */
    onEsc() {
      this.forceRenderComponent();
    }
  }
};
